import React from 'react';
import { Briefcase, FileText, Clock, Trophy } from 'lucide-react';
import { SavedOutput } from '@/api/types';

interface SavedStatsProps {
  outputs: SavedOutput[];
}

export function SavedStats({ outputs }: SavedStatsProps) {
  const stats = {
    total: outputs.length,
    applied: outputs.filter(o => o.status === 'Applied').length,
    interviewing: outputs.filter(o => o.status === 'Interviewing').length,
    offers: outputs.filter(o => o.status === 'Offer').length,
  };

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 mb-6 shrink-0">
      <div className="flex-1 min-w-[130px] bg-white dark:bg-slate-900/50 border border-slate-200 dark:border-slate-800 p-3 rounded-xl flex items-center gap-3 overflow-hidden">
        <div className="p-2 bg-slate-100 dark:bg-slate-800 rounded-lg text-slate-600 dark:text-slate-400 shrink-0">
          <Briefcase className="w-4 h-4" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-xs text-slate-500 dark:text-slate-400 font-medium truncate">Saved Items</div>
          <div className="text-lg font-bold text-slate-800 dark:text-slate-100">{stats.total}</div>
        </div>
      </div>
      <div className="flex-1 min-w-[130px] bg-white dark:bg-slate-900/50 border border-blue-200 dark:border-blue-800/50 p-3 rounded-xl flex items-center gap-3 overflow-hidden">
        <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg text-blue-600 dark:text-blue-400 shrink-0">
          <FileText className="w-4 h-4" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-xs text-blue-600/70 dark:text-blue-400/70 font-medium truncate">Applied</div>
          <div className="text-lg font-bold text-blue-800 dark:text-blue-300">{stats.applied}</div>
        </div>
      </div>
      <div className="flex-1 min-w-[130px] bg-white dark:bg-slate-900/50 border border-purple-200 dark:border-purple-800/50 p-3 rounded-xl flex items-center gap-3 overflow-hidden">
        <div className="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-lg text-purple-600 dark:text-purple-400 shrink-0">
          <Clock className="w-4 h-4" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-xs text-purple-600/70 dark:text-purple-400/70 font-medium truncate">Interviewing</div>
          <div className="text-lg font-bold text-purple-800 dark:text-purple-300">{stats.interviewing}</div>
        </div>
      </div>
      <div className="flex-1 min-w-[130px] bg-white dark:bg-slate-900/50 border border-emerald-200 dark:border-emerald-800/50 p-3 rounded-xl flex items-center gap-3 overflow-hidden">
        <div className="p-2 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg text-emerald-600 dark:text-emerald-400 shrink-0">
          <Trophy className="w-4 h-4" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-xs text-emerald-600/70 dark:text-emerald-400/70 font-medium truncate">Offers</div>
          <div className="text-lg font-bold text-emerald-800 dark:text-emerald-300">{stats.offers}</div>
        </div>
      </div>
    </div>
  );
}
